<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">receipt</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Facturas Exentas</h1>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <!-- Date range -->
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Rango de fechas</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Inicio">
            <input matEndDate formControlName="end" placeholder="Fin">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Fecha inicio inválida</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Fecha fin inválida</mat-error>
        </mat-form-field>

        <!-- Emisor -->
        <form [formGroup]="formEmisor" *ngIf="formEmisor">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Emisor</mat-label>
            <mat-select formControlName="emisor" required>
              <mat-option>Seleccione Emisor</mat-option>
              <mat-option *ngFor="let emisor of emisores" [value]="emisor.rutemisor">
                {{ emisor.cuenta }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>

        <!-- RUT Origen -->
        <form [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>RUT Origen</mat-label>
            <input matInput formControlName="rut_origen" placeholder="Ej: 12345678-9">
          </mat-form-field>
        </form>

        <!-- Email -->
        <form [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="ejemplo@correo.com">
          </mat-form-field>
        </form>

        <!-- Numero ID -->
        <form [formGroup]="filterForm">
          <mat-form-field appearance="outline" class="modern-field w-full">
            <mat-label>Número ID</mat-label>
            <input matInput formControlName="numero_id" placeholder="Ej: 998877">
          </mat-form-field>
        </form>
      </div>

      <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4">
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageIndex]="currentPage"
          [pageSizeOptions]="[10, 20, 50]"
          (page)="onPageChange($event)">
        </mat-paginator>
        <button type="button" (click)="search(true)"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="dataSource">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="w-full">

        <ng-container matColumnDef="cartola_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">{{ row.cartola_id }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="codigo_transferencia">
          <th mat-header-cell *matHeaderCellDef>Cód. Transferencia</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.codigo_transferencia }}</span></td>
        </ng-container>

        <ng-container matColumnDef="rut_origen">
          <th mat-header-cell *matHeaderCellDef>RUT Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.rut_origen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.email }}</span></td>
        </ng-container>

        <ng-container matColumnDef="nombre_origen">
          <th mat-header-cell *matHeaderCellDef>Nombre Origen</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.nombre_origen }}</span></td>
        </ng-container>

        <ng-container matColumnDef="mo_saldo_abono">
          <th mat-header-cell *matHeaderCellDef>Monto</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">{{ row.mo_saldo_abono | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="numero_id">
          <th mat-header-cell *matHeaderCellDef>Número ID</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.numero_id }}</span></td>
        </ng-container>

        <ng-container matColumnDef="doc_fiscal_id">
          <th mat-header-cell *matHeaderCellDef>Doc. Fiscal</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.doc_fiscal_id }}</span></td>
        </ng-container>

        <ng-container matColumnDef="tipo_doc_fiscal">
          <th mat-header-cell *matHeaderCellDef>Tipo Doc.</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipo_doc_fiscal }}</span></td>
        </ng-container>

        <ng-container matColumnDef="emisor">
          <th mat-header-cell *matHeaderCellDef>Emisor</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.emisor }}</span></td>
        </ng-container>

        <ng-container matColumnDef="fecha_emision">
          <th mat-header-cell *matHeaderCellDef>Fecha Emisión</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.fecha_emision | utcToLocalTime:'short' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="ver_pdf">
          <th mat-header-cell *matHeaderCellDef style="text-align: center; width: 80px;">PDF</th>
          <td mat-cell *matCellDef="let row" style="text-align: center; width: 80px;">
            <button title="Ver PDF" (click)="verPdf(row)"
              [disabled]="!row.doc_fiscal_id || !row.usuario_id"
              [style.opacity]="(!row.doc_fiscal_id || !row.usuario_id) ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">picture_as_pdf</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let row of dataSource.filteredData; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full shrink-0">#{{ row.cartola_id }}</span>
          <span class="text-xs font-semibold text-gray-700 truncate">{{ row.nombre_origen }}</span>
          <span class="text-xs font-bold shrink-0" style="color: #1e5a3f;">{{ row.mo_saldo_abono | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}</span>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Cód. Transferencia</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.codigo_transferencia }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">RUT Origen</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.rut_origen }}</p>
          </div>
          <div class="col-span-2">
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Email</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.email }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Número ID</span>
            <p class="text-gray-700 font-mono font-medium mt-0.5">{{ row.numero_id }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Doc. Fiscal</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.doc_fiscal_id }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Doc.</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.tipo_doc_fiscal }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Emisor</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.emisor }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha Emisión</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.fecha_emision | utcToLocalTime:'short' }}</p>
          </div>
        </div>
        <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
          <button title="Ver PDF" (click)="verPdf(row)"
            [disabled]="!row.doc_fiscal_id || !row.usuario_id"
            [style.opacity]="(!row.doc_fiscal_id || !row.usuario_id) ? '0.4' : '1'"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">picture_as_pdf</mat-icon>
            Ver PDF
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
